import { i18n } from '@/i18n';
import { biBrow } from '@tencent/fit-bi-sdk';
import { showBusinessError, hideDialog } from '@tencent/wphk-components-dialog';
import { ReturnActErrMsg } from '@tencent/wphk-components-returning-user/types';
import { getPromiseHandler } from '@tencent/wphk-base-utils';
/** 回流活动执行错误 */
export function showReturnActExecDialog(error: Error) {
  const { name } = error;
  const { resolve, promise } = getPromiseHandler();
  const showErrorDialogAndReport = (e) => {
    // 运营活动-迎新奖赏-全城狂赏主页-错误提示曝光
    showBusinessError(e, {
      btns: [{
        text: i18n('确定'),
        click: () => {
          hideDialog();
          resolve('ok');
        },
      }],
    });
    biBrow('userbackpage.error_brow', {
      ferror: e?.retmsg ? e.retmsg : i18n('網絡異常，請稍後重試'),
    });
  };
  if (Object.keys(ReturnActErrMsg).includes(name)) {
    showErrorDialogAndReport({ retmsg: ReturnActErrMsg[name] });
  } else {
    showErrorDialogAndReport(error);
  }
  return promise;
}
